module.exports = __webpack_public_path__ + "static/media/ev-page-screenshot.a1f5f335.png";